import {
	axios,
	pyAxios
} from '@/utils/request'
import api2 from './index'
const api = {
	user: api2.gateway_system + 'user',
	role: api2.gateway_system + 'role',
	permission: api2.gateway_system + 'menu',
	dept: api2.gateway_system + 'dept',
	dictType: api2.gateway_system + 'dict/type',
	dictData: api2.gateway_system + 'dict/data',
	dist: api2.gateway_system + 'districts',
	config: api2.gateway_system + 'config',
	oss: api2.gateway_system + 'oss'
}

export default api

// user
export function getUserList(parameter) {
	return axios({
		url: api.user + '/list',
		method: 'get',
		params: parameter
	})
}

export function getUser(userId) {
	return axios({
		url: api.user + '/get/' + `${userId}`,
		method: 'get'
	})
}
export function saveUser(parameter) {
	return axios({
		url: api.user + (parameter.userId > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
export function delUser(parameter) {
	return axios({
		url: api.user + '/remove',
		method: 'post',
		params: parameter
	})
}
export function changUserStatus(parameter) {
	return axios({
		url: api.user + '/status',
		method: 'post',
		data: parameter
	})
}
export function resetPwd(parameter) {
	return axios({
		url: api.user + '/resetPwd',
		method: 'post',
		data: parameter
	})
}
export function resetPwd_dept(deptId) {
	return axios({
		url: api.user + '/resetPwd_dept?deptId=' + deptId,
		method: 'post',
	})
}
export function resetPwd_user(parameter) {
	return axios({
		url: api.user + '/resetPwd_user',
		method: 'post',
		data: parameter
	})
}

// role
export function getRoleList(parameter) {
	return axios({
		url: api.role + '/list',
		method: 'get',
		params: parameter
	})
}
export function getRoleAll() {
	return axios({
		url: api.role + '/all',
		method: 'get'
	})
}

export function saveRole(parameter) {
	return axios({
		url: api.role + (parameter.roleId > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}

export function delRole(parameter) {
	return axios({
		url: api.role + '/remove',
		method: 'post',
		params: parameter
	})
}
export function changRoleStatus(parameter) {
	return axios({
		url: api.role + '/status',
		method: 'post',
		data: parameter
	})
}
export function authDataScope(parameter) {
	return axios({
		url: api.role + '/authDataScope',
		method: 'post',
		data: parameter
	})
}

// menu
export function getPermissionAll(parameter) {
	return axios({
		url: api.permission + '/all',
		method: 'get',
		params: parameter
	})
}
export function getPermissions(parameter) {
	return axios({
		url: api.permission + '/list',
		method: 'get',
		params: parameter
	})
}
export function getRolePermIds(roleId) {
	return axios({
		url: api.permission + '/role/' + `${roleId}`,
		method: 'get'
	})
}
export function list_role(parameter) {
	return axios({
		url: api.dept + '/list_role',
		method: 'post',
		data: parameter
	})
}

export function savePerm(parameter) {
	return axios({
		url: api.permission + (parameter.menuId > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}

export function delPerm(deptId) {
	return axios({
		url: api.permission + '/remove/' + `${deptId}`,
		method: 'post'
	})
}

// dept
export function getDeptList(parameter) {
	return axios({
		url: api.dept + '/list',
		method: 'get',
		params: parameter
	})
}
// 查询所有当前部门中的用户
export function user_inDepts2(data) {
	return axios({
		url: api.user + '/list2',
		method: 'get',
		params: data
	}, true)
}
export function getDeptListEnable2(parameter) {
	return axios({
		url: api.dept + '/list/enable2',
		method: 'get',
		params: parameter
	})
}
export function getDeptListEnable3(parameter) {
	return axios({
		url: api.dept + '/list/enable3',
		method: 'get',
		params: parameter
	})
}
// 查询所有当前部门中的用户
export function user_inDepts(data) {
	return axios({
		url: api.user + '/list',
		method: 'get',
		params: data
	}, true)
}
export function getDeptListEnable(parameter) {
	return axios({
		url: api.dept + '/list/enable',
		method: 'get',
		params: parameter
	})
}
export function getRoleDeptIds(roleId) {
	return axios({
		url: api.dept + '/role/' + `${roleId}`,
		method: 'get'
	})
}
export function saveDept(parameter) {
	return axios({
		url: api.dept + (parameter.deptId > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}

export function delDept(deptId) {
	return axios({
		url: api.dept + '/remove/' + `${deptId}`,
		method: 'post'
	})
}
// dictType
export function getDictTypeList(parameter) {
	return axios({
		url: api.dictType + '/list',
		method: 'get',
		params: parameter
	})
}
export function saveDictType(parameter) {
	return axios({
		url: api.dictType + (parameter.dictId > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
export function delDictType(parameter) {
	return axios({
		url: api.dictType + '/remove',
		method: 'post',
		params: parameter
	})
}

// dictData
export function getDictDataList(parameter) {
	return axios({
		url: api.dictData + '/list',
		method: 'get',
		params: parameter
	})
}
export function saveDictData(parameter) {
	return axios({
		url: api.dictData + (parameter.dictCode > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
export function delDictData(parameter) {
	return axios({
		url: api.dictData + '/remove',
		method: 'post',
		params: parameter
	})
}
// dist 地区
export function getDistList(parameter) {
	return axios({
		url: api.dist + '/list',
		method: 'get',
		params: parameter
	})
}
// 新增地区
export function districtsAdd(parameter) {
	return axios({
		url:  api2.gateway_system + 'districts/add',
		method: 'post',
		data: parameter
	})
}
// 编辑地区
export function districtsEdit(parameter) {
	return axios({
		url:  api2.gateway_system + '/districts/edit',
		method: 'post',
		data: parameter
	})
}
//批量删除
export function districtsDelete(key) {
	return axios({
		url: api2.gateway_system + 'districts/' + `${key}`,
		method: 'delete'
	})
}

export function saveDist(parameter) {
	return axios({
		url: api.dist + (parameter.id > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
export function delDist(parameter) {
	return axios({
		url: api.dist + '/remove',
		method: 'post',
		params: parameter
	})
}
// config 配置
export function getConfigList(parameter) {
	return axios({
		url: api.config + '/list',
		method: 'get',
		params: parameter
	})
}
export function saveConfig(parameter) {
	return axios({
		url: api.config + (parameter.configId > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
export function delConfig(parameter) {
	return axios({
		url: api.config + '/remove',
		method: 'post',
		params: parameter
	})
}
// oss
export function getOssList(parameter) {
	return axios({
		url: api.oss + '/list',
		method: 'get',
		params: parameter
	})
}
export function saveOss(parameter) {
	return axios({
		url: api.oss + (parameter.id > 0 ? '/update' : '/save'),
		method: 'post',
		data: parameter,
		headers: {
			'Content-Type': 'application/json;charset=UTF-8'
		}
	})
}
export function delOss(parameter) {
	return axios({
		url: api.oss + '/remove',
		method: 'post',
		params: parameter
	})
}
export function getOssConfig() {
	return axios({
		url: api.oss + '/config',
		method: 'get'
	})
}
export function saveOssConfig(parameter) {
	return axios({
		url: api.oss + '/saveConfig',
		method: 'post',
		params: parameter
	})
}


//获取帮助中心列表
export function get_list_faq(parameter) {
	return axios({
		url: '/daily/daily/fag/list',
		method: 'get',
		params: parameter
	})
}
//新增帮助中心
export function addFag(parameter) {
	return axios({
		url: '/daily/daily/fag',
		method: 'post',
		data: parameter
	})
}
//编辑帮助中心
export function editFag(data) {
	return axios({
		url: '/daily/daily/fag',
		method: 'put',
		data: data
	})
}
//删除帮助中心
export function deleteFag(parameter) {
	return axios({
		url: '/daily/daily/fag',
		method: 'delete',
		params: parameter
	})
}


// 获取常见问题接口
// export function get_list_faq() {
// 	return pyAxios({
// 		url: 'help/hot/get_list',
// 		method: 'get',
// 	})
// }

// 获取常见问题详情接口
// export function get_list_part() {
// 	return pyAxios({
// 		url: 'help/faq/get_list',
// 		method: 'get',
// 	})
// }
// 获取总资产金额接口 
// export function get_total_value(data) {
// 	return pyAxios({
// 		url: 'stats/asset/get_total_value',
// 		method: 'get',
// 		params: data
// 	})
// }
// 获取总资产金额比例 
// export function get_value_proportion(data) {
// 	return pyAxios({
// 		url: 'stats/asset/get_value_proportion',
// 		method: 'get',
// 		params: data
// 	})
// }
// 统计分析，耗材总金额接口
// export function sku_get_total_value(data) {
// 	return pyAxios({
// 		url: 'stats/sku/get_total_value',
// 		method: 'get',
// 		params: data
// 	})
// }
// 获取系统更新接口
// export function get_list_update(data) {
// 	return pyAxios({
// 		url: 'help/version/get_list',
// 		method: 'get',
// 		params: data
// 	})
// }

//第一个采购价格
// export function asset_get_total_price(data) {
// 	return pyAxios({
// 		url: 'stats/asset/get_total_price',
// 		method: 'get',
// 		params: data
// 	}, true)
// }
//固定资产分析
export function fixedAssetsChange(data) {
	return axios({
		url: '/daily/asset',
		method: 'get',
		params: data
	}, true)
}
//固定资产占比分析
export function fixedAssetsAnalysis(data) {
	return axios({
		url: '/daily/proportion',
		method: 'get',
		params: data
	}, true)
}
//总资产对比
export function assetsContrast(data) {
	return axios({
		url: '/daily/contrast',
		method: 'get',
		params: data
	}, true)
}
//总资产趋势
export function assetsContrastMonth(data) {
	return axios({
		url: '/daily/contrast/month',
		method: 'get',
		params: data
	}, true)
}
//第三个采购价格
// export function sku_get_total_price(data) {
// 	return pyAxios({
// 		url: 'stats/sku/get_total_price',
// 		method: 'get',
// 		params: data
// 	}, true)
// }

// 第二个
// export function asset_get_price_proportion(data) {
// 	return pyAxios({
// 		url: 'stats/asset/get_price_proportion',
// 		method: 'get',
// 		params: data
// 	}, true)
// }

// 获取页问答
// export function hot_get_list(parameter) {
// 	return pyAxios({
// 		url: '/help/hot/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }
//新增首页问答
// export function hot_add(parameter) {
// 	return pyAxios({
// 		url: '/help/hot/add',
// 		method: 'post',
// 		data: parameter
// 	})
// }
//新增首页修改
// export function hot_update(parameter) {
// 	return pyAxios({
// 		url: '/help/hot/update',
// 		method: 'post',
// 		data: parameter
// 	})
// }

//删除首页问答
// export function hot_del(parameter) {
// 	return pyAxios({
// 		url: '/help/hot/del',
// 		method: 'get',
// 		params: parameter
// 	})
// }


// 获取常见问题问答
// export function faq_get_list(parameter) {
// 	return pyAxios({
// 		url: '/help/faq/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }
//新增常见问题问答
// export function faq_add(parameter) {
// 	return pyAxios({
// 		url: '/help/faq/add',
// 		method: 'post',
// 		data: parameter
// 	})
// }
//新增常见问题修改
// export function faq_update(parameter) {
// 	return pyAxios({
// 		url: '/help/faq/update',
// 		method: 'post',
// 		data: parameter
// 	})
// }

//删除常见问题问答
// export function faq_del(parameter) {
// 	return pyAxios({
// 		url: '/help/faq/del',
// 		method: 'get',
// 		params: parameter
// 	})
// }


// 获取版本更新
// export function version_get_list(parameter) {
// 	return pyAxios({
// 		url: '/help/version/get_list',
// 		method: 'get',
// 		params: parameter
// 	})
// }
//新增版本更新
// export function version_add(parameter) {
// 	return pyAxios({
// 		url: '/help/version/add',
// 		method: 'post',
// 		data: parameter
// 	})
// }
//版本更新修改
// export function version_update(parameter) {
// 	return pyAxios({
// 		url: '/help/version/update',
// 		method: 'post',
// 		data: parameter
// 	})
// }

//删除版本更新
// export function version_del(parameter) {
// 	return pyAxios({
// 		url: '/help/version/del',
// 		method: 'get',
// 		params: parameter
// 	})
// }

//默认抄送人
export function nacos_cc(parameter) {
	return axios({
		url: api2.gateway_act+'nacos/cc',
		method: 'get',
		params: parameter
	})
}
//新增版本更新
export function versionAdd(parameter) {
	return axios({
		url: '/daily/daily/help/version',
		method: 'post',
		data: parameter
	})
}
//查询所有版本
export function versionList(parameter) {
	return axios({
		url: '/daily/daily/help/version/list',
		method: 'get',
		params: parameter
	})

// =======
}
// 修改版本
export function versionEdit(data) {
	return axios({
	  url: '/daily/daily/help/version',
	  method: 'put',
	  data: data
	})
  }
//删除版本
export function versionDelete(parameter) {
	return axios({
		url: '/daily/daily/help/version',
		method: 'delete',
		params: parameter
	})
}
//查询角色列表
export function authRoles(parameter) {
	return axios({
		url: '/daily/auth/roles',
		method: 'get',
		params: parameter
	})
}
//查询已选择的权限列表
export function authDepts(parameter) {
	return axios({
		url: '/daily/auth/depts',
		method: 'get',
		params: parameter
	})
}
//保存修改的权限
export function authInfo(parameter) {
	return axios({
		url: '/daily/auth/info',
		method: 'post',
		data: parameter
	})
}
//获得隐私
export function getPrivacy(parameter) {
	return axios({
		url: '/daily/protocol/info',
		method: 'get',
		params: parameter
	})
}
//考勤管理列表
export function list_page(parameter) {
	return axios({
		url: '/daily/daily_visit/list_page',
		method: 'get',
		params: parameter
	})
}
//按指定日期获取单个日报
export function getDailyOne(parameter) {
	return axios({
		url: '/daily/daily/getDailyOne',
		method: 'get',
		params: parameter
	})
}
//财务申请新增权限
export function insertLimitInfo(parameter) {
	return axios({
		url: '/act/limit/insertLimitInfo',
		method: 'post',
		data: parameter
	})
}
//获取财务流程权限
export function findLimitInfo(parameter) {
	return axios({
		url: '/act/limit/findLimitInfo',
		method: 'get',
		params: parameter
	})
}